import { Component, OnInit } from '@angular/core'
import { Observable, fromEvent, merge, of } from 'rxjs'
import { map } from 'rxjs/operators'

interface NavSection {
    anchor: string
    icon: string
    label: string
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit {
    isHandset$: Observable<boolean>
    sections: NavSection[] = [
        { anchor: 'home', icon: 'home', label: 'Home' },
        { anchor: 'about', icon: 'person', label: 'About' },
        { anchor: 'skills', icon: 'code', label: 'Skills' },
        { anchor: 'experience', icon: 'work', label: 'Experience' },
        { anchor: 'projects', icon: 'dashboard', label: 'Projects' },
        { anchor: 'contact', icon: 'mail', label: 'Contact' },
    ]

    ngOnInit(): void {
        this.isHandset$ = merge(of(null), fromEvent(window, 'resize')).pipe(
            map(() => window.innerWidth <= 767)
        )
    }

    nav(anchor: string): void {
        document.querySelector('#' + anchor)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }
}
